import _ from "lodash";

export const addUser = (state, action) => {
  let list = state.list;
  const savedUser = action.payload;
  return [savedUser, ...list];
};

export const updateUser = (state, action) => {
  let list = state.list;
  const updatedUser = action.payload;

  const index = _.findIndex(list, ["id", updatedUser.id]);
  list[index] = updatedUser;

  return [...list];
};

export const removeUser = (state, action) => {
  let list = state.list;
  const deletedUser = action.payload;

  const filteredList = _.filter(list, function (td) {
    return td.id !== deletedUser.id;
  });

  return [...filteredList];
};
export const formtValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};
